export function isValidZipCode(zipCode: string | null) {
  return zipCode && /^\d{5}(-\d{4})?$/.test(zipCode);
}
